import { PropsWithChildren, useReducer } from 'react';

import { SnackbarContext } from './context';
import { SnackbarReducer } from './reducer';

export const SnackbarContextProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const [state, dispatch] = useReducer(SnackbarReducer, {});
  return (
    <SnackbarContext.Provider
      value={{
        snackbarState: state,
        snackbarDispatch: dispatch,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};
